function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M614.299 270.039V588.893h-74.528V539.63H100.217v49.264H25.688V270.04H-.001v-49.028h62.683l34.96-108.745c10.3-32.02 27.52-61.158 61.159-61.158h335.366c33.638 0 53.044 28.535 61.158 61.158l27.036 108.745h57.627v49.028h-25.69zM208.373 441.254h220.148v51.91H208.373v-51.91zM50.647 320.343c56.103 1.76 90.415 25.276 99.237 74.245H50.647v-74.245zm531.644 0c-56.091 1.76-90.415 25.276-99.226 74.245h99.226v-74.245zM89.482 221.011h461.037l-19.76-91.182c-5.421-25.004-20.977-46.595-46.607-46.595H165.309c-25.618 0-38.764 22.181-46.595 46.595L89.48 221.01z"
});

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 640 640",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car.c6145839.svg";
export { ForwardRef as ReactComponent };